module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon9.c7c6ff79.svg";